import Vue from 'vue'
import EventBus from '../_event-bus'

Vue.component('vue-prize-box', {
  template: '#vue-prize-box-template',
  props: ['add-to-cart-text', 'moreButtonText', 'prize', 'signUpText'],
  computed: {
    isAflofarmPlus,
    pointsTitle,
  },
  methods: {
    addToCart,
    openModal,
  },
})

function addToCart(id) {
  EventBus.$emit('add-to-cart', { id })
}

function isAflofarmPlus() {
  return document.body.classList.contains('is-aflofarm-plus')
}

function openModal() {
  EventBus.$emit('open-modal', {
    addToCartText: this.$props.addToCartText,
    pointsTitle: this.pointsTitle,
    modal: this.$props.prize,
  })
}

function pointsTitle() {
  if (this.prize.pointsType === 'aflo') return 'Punktów AflofarmPLUS'
  if (this.prize.pointsType === 'edu') return 'Punktów edukacjynych'
  return ''
}
